import React, { useEffect, useState } from 'react'
import { FaEye } from 'react-icons/fa6';
import { IoIosAddCircleOutline } from 'react-icons/io';
import { FallingLines } from 'react-loader-spinner'
import { base_url } from '../../utils/AxiosConfig';
import axios from 'axios';
import HolidaySettingPopup from './HolidaySettingPopup';
import ViewHolidayPopUp from './ViewHolidayPopUp';
import { LuPanelLeftOpen, LuPanelRightOpen } from 'react-icons/lu';
import { IoPersonAddSharp } from "react-icons/io5";
import { toast } from "react-toastify";



const HolidaySettings = () => {


  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }

  const [data, setData] = useState();
  const [popUpData, setpopUpData] = useState();
  const [Open, setOpen] = useState(false);
  const [reset, setReset] = useState(false);
  const [loader, setLoader] = useState(true);
  const [filterview, setFilterView] = useState(false);
  const [addView, setAddView] = useState(false);
  const [searchdata, setSearchData] = useState();
  const [selectedJob, setSelectedJobTitle] = useState(null);
  const [jobtitle, setJobTitle] = useState(null);
  const [selectedgrade, setSelectedGrade] = useState(false);
  const [grade, setGrade] = useState(false);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [Division, setDivision] = useState(null);
  const [resetalldata, setResetallData] = useState(false);
  const [alldata, setallData] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [LeaveData, setLeaveData] = useState();
  const [DataLeave, setDataLeave] = useState();

  const [leaveDate, setleaveDate] = useState([]);
  const [leaveType, setLeaveType] = useState('');

  const [combinedData, setCombinedData] = useState([])
  const [EmpId, setEmpId] = useState('')

  const [allBranchData, setAllBranchData] = useState([])

  const [holidayHomeView, setHolidayHomeView] = useState('Settings')

  const [allBranchFetchLoader, setAllBranchFetchLoader] = useState(false)

  const handleChildData = (formattedDates, selectedLeaveType, EmpId) => {
    // console.log(formattedDates, selectedLeaveType, EmpId,'from child')
    setleaveDate(formattedDates);
    setLeaveType(selectedLeaveType);
    setEmpId(EmpId)
  };

  const fetchAllBranchData = async () => {
    setAllBranchFetchLoader(true)
    try {
      const response = await axios.get(`${base_url}/api/MasterCount/${companyCode}/BRANCH/-/-`)

      if (response.status === 200) {
        setAllBranchData(response.data)
        setAllBranchFetchLoader(false)
      }
    } catch (error) {
      console.log('fetchAllBranchDataErr', error)
      setAllBranchFetchLoader(false)
    }
  }

  useEffect(() => {
    fetchAllBranchData()
  }, [])


  // console.log(leaveDate,leaveType,'states')
  // pagination
  const [currentPage, SetcurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = data?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(data?.length / recordsPerPage);
  const numbers = Array.from({ length: npage }, (_, i) => i + 1);

  useEffect(() => {
    if (data) {
      setLoader(false);
    }
  }, [data]);
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);

          setReset(false);
        }
      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);
          setallData(false);
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, [alldata, apiData]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
      );
      if (response?.data) {
        setData(response.data);
        setSearchData("");
        setSelectedJobTitle("");
        setSelectedDivision("");
        setSelectedGrade("");
        setResetallData(false);
      }
    };
    if (resetalldata === true || selectedJob === '' && selectedDivision === '' && selectedgrade === '') {
      getData();
      console.log("Reset All Data");
    }
  }, [resetalldata, selectedDivision, selectedJob, selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, [selectedDivision, selectedJob, selectedgrade]);


  useEffect(() => {
    if (selectAll === true) {
      setAddView(true);
    } else {
      setAddView(false);
    }
  }, [selectAll]);

  useEffect(() => {
    const LeavePostData = async () => {
      try {
        const Res = await axios
          .post(
            `${base_url}/api/PersonalInfoLeaveAllotmentReg`,
            apiData
          )
          .then((Res) => {
            if (Res.status === 200) {
              toast.success("Leave Alloted Successfully");
            } else if (Res.status === 408) {
              toast.error("Something Went wrong ");
            } else if (Res.status === 415) {
              toast.error("Something Went wrong ");
            } else {
              toast.error("Something Went wrong ");
            }
          });
      } catch (error) {
        console.log(error);
      }
    };

    if (apiData) {
      LeavePostData();
    }
  }, [apiData]);

  useEffect(() => {
    const getLeave = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`
        );
        if (response?.data) {
          setLeaveData(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoLeaveCategoryListerror:', error);
      }
    };

    getLeave();
  }, [apiData]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/ALL/ALL/ALL/ALL`
        );
        if (response?.data) {
          setData(response.data);
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getSearch = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/FREETEXT/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };
    if (searchdata) {
      setTimeout(() => {
        getSearch();
      }, 10);
    } else {
      const getData = async () => {
        try {
          const response = await axios.get(
            `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
            }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
            }/${selectedDivision ? selectedDivision : "ALL"}`
          );
          if (response?.data) {
            setData(response.data);
          }

        } catch (error) {
          console.error('PersonalInfoListEerror:', error);
        }
      };

      getData();
    }
  }, [searchdata]);

  useEffect(() => {
    const getFilteredData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };
    if (selectedJob) {
      console.log(selectedJob, 'selectedJob')
      getFilteredData();
    } else if (selectedJob === '' && selectedDivision === '' && selectedgrade === '') {
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedJob]);


  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };
    if (selectedDivision) {
      console.log(selectedDivision, 'selectedDivision')
      console.log((typeof (selectedDivision)), 'selectedDivisionType')
      getFilteredData();
    } else if (selectedJob === '' && selectedDivision === '' && selectedgrade === '') {
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedJob);
  }, [selectedDivision]);

  useEffect(() => {
    const getFilteredData = async () => {
      let decode = decodeURI(selectedJob ? selectedJob : null);
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : "ALL"
          }/${selectedJob ? selectedJob : "ALL"}/${selectedgrade !== "Grade" ? selectedgrade : "ALL"
          }/${selectedDivision ? selectedDivision : "ALL"}`
        );
        if (response?.data) {
          setData(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoListEerror:', error);
      }
    };
    if (selectedgrade) {
      console.log(selectedgrade, 'selectedgrade')
      getFilteredData();
    } else if (selectedJob === '' && selectedDivision === '' && selectedgrade === '') {
      console.log('reset activated')
      setResetallData(true);
    }

    console.log(selectedgrade);
  }, [selectedgrade]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/DIVISION/-`
      );
      if (response?.data) {
        setDivision(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MasterList/${companyCode}/JOBTITLE/-`
      );
      if (response?.data) {
        setJobTitle(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`
      );
      if (response?.data) {
        setGrade(response.data);
      } else {
        console.log("error");
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (searchdata && data === null) {
      setLoader(true);
    } else if (searchdata && data) {
      setLoader(false);
    }
  }, [searchdata, data]);

  useEffect(() => {
    if (records) {
      setLoader(false);
    }
  }, [records]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveAllotment/${companyCode}/ALL/-`
        );
        if (response?.data) {
          setDataLeave(response.data);
        } else {
          console.log("error");
        }

      } catch (error) {
        console.error('PersonalInfoLeaveAllotmenterror:', error);
      }
    };

    getData();
  }, []);

  // console.log(selectedJob,selectedDivision,selectedgrade,leaveType,leaveDate,EmpId)

  useEffect(() => {
    // Only proceed if all necessary data is available
    if (leaveType && leaveDate && EmpId) {
      // Create an object with the selected data
      const employeeObject = {
        selectedJob: selectedJob || 'All',
        selectedDivision: selectedDivision || 'All',
        selectedgrade: selectedgrade || 'All',
        leaveType,
        leaveDate,
        EmpId,
      };

      // Find the index of the employee in the array
      const index = combinedData.findIndex((employee) => employee.EmpId === EmpId);

      // Update or add the employee object in the array
      if (index !== -1) {
        // Employee already exists, update the object at the index
        const updatedEmployeeData = [...combinedData];
        updatedEmployeeData[index] = employeeObject;
        setCombinedData(updatedEmployeeData);
      } else {
        // Employee does not exist, add a new object to the array
        setCombinedData([...combinedData, employeeObject]);
      }
    }
  }, [selectedJob, selectedDivision, selectedgrade, leaveType, leaveDate, EmpId])

  console.log(combinedData, 'combinedData')

  return (
<div className="max-w-7xl mx-auto">
  <div className="rounded-lg">

    {/* Header */}
    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
      {/* <h2 className="text-xl font-semibold text-gray-800">Holiday Management</h2> */}

      <h6 className="mb-4 text-2xl font-bold text-gray-600 flex  justify-start items-center">
                {/* <MdPeopleOutline className="mr-2" /> */}

                {/* <span>Holiday Management</span> */}
                <span>Holiday Setting</span>
              </h6>

      {/* Action Buttons */}
      <div className="flex gap-3 mt-4 md:mt-0">
        <button
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition"
          onClick={() => setHolidayHomeView('Settings')}
        >
          <IoIosAddCircleOutline className="text-lg" />
          <span>Setting</span>
        </button>

        <button
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md transition"
          onClick={() => setHolidayHomeView('View')}
        >
          <FaEye className="text-lg" />
          <span>List</span>
        </button>
      </div>
    </div>

    {/* Conditional Views */}
    <div className='shadow-md rounded-lg'>
      {holidayHomeView === 'Settings' && (
        <HolidaySettingPopup
          popUpData={popUpData}
          onDataUpdate={handleChildData}
          allBranchData={allBranchData}
          allBranchFetchLoader={allBranchFetchLoader}
        />
      )}

      {holidayHomeView === 'View' && (
        <ViewHolidayPopUp
          popUpData={popUpData}
          allBranchData={allBranchData}
        />
      )}
    </div>
  </div>
</div>

  )
  function prePage() {
    if (currentPage !== firstIndex) {
      SetcurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    SetcurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== lastIndex) {
      SetcurrentPage(currentPage + 1);
    }
  }
}

export default HolidaySettings
